import {WechatService} from "../service/wechatservice";
import {TokenType, WechatInitOptions} from "../base/options";
import * as rp from "request-promise";
import {TokenService} from "./tokenservice";

/**
 * 打开 access token 服务
 */
export class CheckInTokenService extends TokenService {

  /**
   * @override
   */
  async setAccessToken(): Promise<string> {
    let wechatOptions: WechatInitOptions = await WechatService.getWechatOptions();

    let result: any = await rp({
      method: "GET",
      uri: `${wechatOptions.corp.apiUrl}gettoken?corpid=${wechatOptions.corp.corpId}&corpsecret=${wechatOptions.corp.checkInSecret}`,
      json: true
    });
    if (!result.errcode) {
      delete result.errcode;
      delete result.errmsg;

      // 过期时间，因网络延迟等，将实际过期时间提前100秒
      result.expires_at = (new Date().getTime()) + (result.expires_in - 100) * 1000;

      // 更新缓存
      wechatOptions.tokenCache.updateToken(TokenType.checkInSecret, JSON.stringify(result));

      return result.access_token;
    } else {
      console.error(`gettoken failed , response:`);
      console.error(result);
    }

    return "";
  }

  /**
   * @override
   */
  async getAccessToken(): Promise<string> {
    let wechatOptions: WechatInitOptions = await WechatService.getWechatOptions();

    // 从缓存中获取token
    let tokenStr: string = await wechatOptions.tokenCache.getToken(TokenType.checkInSecret);
    if (tokenStr) {
      let tokenJson: any = JSON.parse(tokenStr);

      let nowTime: number = new Date().getTime();
      // 如已过期，重新获取
      if (tokenJson.expires_at < nowTime) {
        return await this.setAccessToken();
      } else {
        return tokenJson.access_token;
      }
    } else {
      return await this.setAccessToken();
    }
  }
}
